module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/management/processes/processes-show/processes-show.component.scss
// module id = ./src/app/views/management/processes/processes-show/processes-show.component.scss
// module chunks = main